import React, { useState } from "react";
import TableCell from "@mui/material/TableCell";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import InfoIcon from "@mui/icons-material/Info";
import Tooltip from "@mui/material/Tooltip";
import Collapse from "@mui/material/Collapse";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import Box from "@mui/material/Box";
import { Grid } from "@mui/material";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import FormControlLabel from "@mui/material/FormControlLabel";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import UiSwitch from "../../../_uiMocks/_uiComponents/UiSwitch";
import UiTableBody from "../../../_uiComponents/common/table/UiTableBody";
import UiTableHead from "../../../_uiMocks/_uiComponents/UiTableHead";
import UiTableWrapper from "../../../_uiComponents/common/table/UiTableWrapper";
import {
     UiGridType,
     ApprovedIcon,
     NotApprovedIcon,
} from "../../../_uiComponents/common/DataGridComponents";
import UiSearch from "../../../_uiMocks/_uiComponents/UiSearch";
import {
     DragAndDrop,
     Drag,
     Drop,
} from "../../../_uiComponents/common/drag-and-drop";
import UiInput from "../../../_uiMocks/_uiComponents/UiInput";
import UiSelect from "../../../_uiMocks/_uiComponents/UiSelect";
import { UiButton } from "../../../_uiComponents/common/form/UiButton";
import UiModal from "../../../_uiComponents/common/UiModal";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import UiConfirmationDialog from "../../../_uiComponents/common/UiConfirmationDialog";


function descendingComparator(a, b, orderBy) {
     if (b[orderBy] < a[orderBy]) {
          return -1;
     }
     if (b[orderBy] > a[orderBy]) {
          return 1;
     }
     return 0;
}

function getComparator(order, orderBy) {
     return order === "desc"
          ? (a, b) => descendingComparator(a, b, orderBy)
          : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
     const stabilizedThis = array.map((el, index) => [el, index]);
     stabilizedThis.sort((a, b) => {
          const order = comparator(a[0], b[0]);
          if (order !== 0) {
               return order;
          }
          return a[1] - b[1];
     });
     return stabilizedThis.map((el) => el[0]);
}

export default function LookupTableManagement(props) {
     const [page, setPage] = React.useState(0);
     const [rowsPerPage, setRowsPerPage] = React.useState(3);
     const [order, setOrder] = React.useState("asc");
     const [orderBy, setOrderBy] = React.useState();
     const [open, setOpen] = React.useState(false);
     const [active, setActive] = React.useState();
     const [editModal, setEditModal] = React.useState(false);
     const [character, setCharacter] = React.useState("");
     const [dialogOpen, setDialogOpen] = React.useState(false);

     const handleEditShow = () => setEditModal(true);
     const handleCloseEdit = () => setEditModal(false);

     const manageOpen = (clickedIndex) => {
          if (active === clickedIndex) {
               setActive(null);
               setOpen(true);
          } else {
               setActive(clickedIndex);
               setOpen(true);
          }
     };

     const dialogHandleOpen = () => {
          setDialogOpen(true);
     };

     const dialogHandleClose = () => {
          setDialogOpen(false);
     };

     //Pagination
     const handleChangePage = (event, newPage) => {
          setPage(newPage);
     };
     const handleChangeRowsPerPage = (event) => {
          setRowsPerPage(+event.target.value);
          setPage(0);
     };

     //Sorting
     const handleRequestSort = (event, property) => {
          console.log(property)
          const isAsc = orderBy === property && order === "asc";
          console.log(isAsc)
          setOrder(isAsc ? "desc" : "asc");
          setOrderBy(property);
     };
     const options1 = [
          { value: "value-1", label: "Sales" },
          { value: "value-2", label: "Sales" },
          { value: "value-3", label: "Sales" },
     ];

     const handleChangetype = (event) => {
          setCharacter(event.target.value);
     };

     const headings = [
          { id: "name", name: "Name" },
          { id: "type", name: "Type" },
          { id: "label", name: "Labels" },
          { id: "records", name: "Records" },
          { id: "inuse", name: "In Use" },
          { id: "active", name: "Active" },
          { id: "", name: "" },
          { id: "", name: "" },
     ];

     const rows = [
          {
               id: 1,
               name: "Sales type",
               typeSt: "1",
               label: "sales2",
               total_records: 1,
               in_use: true,
               enable: true,
               items: [
                    {
                         id: 1,
                         date: "2020-01-05",
                    },
                    {
                         id: 2,
                         date: "2020-01-02",
                    },
               ],
          },
          {
               id: 2,
               name: "Color",
               typeSt: "2",
               label: "sales3",
               total_records: 5,
               in_use: false,
               enable: false,
               items: [
                    {
                         id: 1,
                         date: "2020-01-05",
                         customerId: "11091700",
                    },
                    {
                         id: 2,
                         date: "2020-01-02",
                         customerId: "Anonymous",
                    },
               ],
          },
          {
               id: 3,
               name: "Model",
               typeSt: "3",
               label: "sales",
               total_records: 18,
               in_use: false,
               enable: true,
               items: [
                    {
                         id: 1,
                         date: "2020-01-05",
                         customerId: "11091700",
                    },
                    {
                         id: 2,
                         date: "2020-01-02",
                         customerId: "Anonymous",
                    },
               ],
          },
     ];

     //Empty rows issue set
     const emptyRows =
          page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;
     console.log(emptyRows);
     const [newRows, setNewRows] = React.useState(rows);
     const [subTableData, setSubTableData] = useState(rows);

     //Add row modal
     const [openAddFieldModal, setOpenAddFieldModal] = React.useState(false);
     const subTableModalOpen = () => setOpenAddFieldModal(true);
     const handleClose = () => setOpenAddFieldModal(false);

    

     //Data sorting
     const visibleRows = React.useMemo(
          () =>
               stableSort(rows, getComparator(order, orderBy)).slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage,
               ),
          [order, orderBy, page, rowsPerPage, rows],
     );

   

     //Drag and drop reorder
     const reorder = (list, startIndex, endIndex) => {
          const result = Array.from(list);
          const [removed] = result.splice(startIndex, 1);
          result.splice(endIndex, 0, removed);
          return result;
     };

     //Switch function
     const handleChange = (event, index) => {
          let newArr = [...newRows];
          newArr[index].enable = event.target.checked;
          setNewRows(newArr);
     };

     //Ondrag function
     const onDragEnd = (result) => {
          const { type, source, destination } = result;
          if (!destination) return;
          const sourceCategoryId = source.droppableId;
          const destinationCategoryId = destination.droppableId;

          if (type === "droppable-item") {
               if (sourceCategoryId === destinationCategoryId) {
                    const updatedOrder = reorder(
                         subTableData.find(
                              (category) => category.id === sourceCategoryId,
                         ).items,
                         source.index,
                         destination.index,
                    );
                    const updatedCategories = subTableData.map((category) =>
                         category.id !== sourceCategoryId
                              ? category
                              : { ...category, items: updatedOrder },
                    );
                    setSubTableData(updatedCategories);
               }
          }
     };

     return (
          <>
         
               <div className="sba-table-main-wr">
                    <UiTableWrapper>
                         <UiTableHead
                              headings={headings}
                              order={order}
                              orderBy={orderBy}
                              onRequestSort={handleRequestSort}
                         />

                         <UiTableBody>
                              {visibleRows.map((row, index) => (
                                   <>
                                        <TableRow
                                             key={row.id}
                                             sx={{
                                                  "&:last-child td, &:last-child th":
                                                       { border: "none" },
                                             }}
                                        >
                                             <TableCell align="left">
                                                  <strong>{row.name}</strong>
                                             </TableCell>
                                             <TableCell align="center">
                                                  <strong>{row.typeSt}</strong>
                                             </TableCell>
                                             <TableCell align="center">
                                                  <UiGridType
                                                       name={row.label}
                                                  />
                                             </TableCell>
                                             <TableCell align="center">
                                                  {row.total_records}
                                             </TableCell>
                                             <TableCell align="center">
                                                  {row.in_use ? (
                                                       <ApprovedIcon />
                                                  ) : (
                                                       <NotApprovedIcon />
                                                  )}{" "}
                                             </TableCell>
                                             <TableCell align="center">
                                                  <UiSwitch
                                                       checked={row.enable}
                                                       handleChange={(
                                                            event,
                                                       ) => {
                                                            handleChange(
                                                                 event,
                                                                 index,
                                                            );
                                                       }}
                                                       name={row.name}
                                                  />
                                             </TableCell>
                                             <TableCell align="right">
                                                  <Button
                                                       size="small"
                                                       variant="outlined"
                                                       endIcon={
                                                            active == index &&
                                                                 open ? (
                                                                 <KeyboardArrowUpIcon />
                                                            ) : (
                                                                 <KeyboardArrowDownIcon />
                                                            )
                                                       }
                                                       onClick={() => {
                                                            manageOpen(index);
                                                       }}
                                                  >
                                                       Manage
                                                  </Button>
                                             </TableCell>
                                             <TableCell
                                                  align="right"
                                                  sx={{ width: "110px" }}
                                             >
                                                  <div className="sbt-data-grid__action-bar">
                                                       <InfoIcon className="sba-grid-info-icon" />
                                                       <Tooltip
                                                            title="Edit"
                                                            placement="top"
                                                            arrow
                                                       >
                                                            <IconButton
                                                                 aria-label="Edit"
                                                                 onClick={
                                                                      handleEditShow
                                                                 }
                                                                 sx={{
                                                                      ml: 1.5,
                                                                 }}
                                                            >
                                                                 <EditIcon />
                                                            </IconButton>
                                                       </Tooltip>
                                                       <Tooltip
                                                            title="Delete"
                                                            placement="top"
                                                            arrow
                                                       >
                                                            <IconButton
                                                                 aria-label="delete"
                                                                 sx={{
                                                                      ml: 0.5,
                                                                 }}
                                                                 onClick={
                                                                      dialogHandleOpen
                                                                 }
                                                            >
                                                                 <DeleteIcon color="error" />
                                                            </IconButton>
                                                            <UiConfirmationDialog
                                                                 title="Delete Confirmation"
                                                                 open={
                                                                      dialogOpen
                                                                 }
                                                                 onClose={
                                                                      dialogHandleClose
                                                                 }
                                                            >
                                                                 <h5>
                                                                      Are you
                                                                      sure, you
                                                                      want to
                                                                      delete ?
                                                                 </h5>
                                                            </UiConfirmationDialog>
                                                       </Tooltip>
                                                  </div>
                                             </TableCell>
                                        </TableRow>

                                        <TableRow>
                                             <TableCell
                                                  style={{
                                                       paddingBottom: 0,
                                                       paddingTop: 0,
                                                       border: "none",
                                                       background: "#f9f8f8",
                                                       borderBottom: "none",
                                                  }}
                                                  colSpan={12}
                                             >
                                                  <Collapse
                                                       in={
                                                            active == index &&
                                                            open
                                                       }
                                                       timeout="auto"
                                                       unmountOnExit
                                                  >
                                                       <Box sx={{ margin: 1 }}>
                                                            <h2 className="sba-create-fact-table-heading">
                                                                 Manage Lookup
                                                                 Values
                                                            </h2>
                                                            <div className="sba-subtable-top-btns">
                                                                 <div className="sba-add-row-button">
                                                                      <Button
                                                                           variant="contained"
                                                                           startIcon={
                                                                                <AddIcon />
                                                                           }
                                                                           onClick={
                                                                                subTableModalOpen
                                                                           }
                                                                      >
                                                                           Add
                                                                           Value
                                                                      </Button>
                                                                 </div>
                                                                 <UiModal
                                                                      handleClose={
                                                                           handleClose
                                                                      }
                                                                      open={
                                                                           openAddFieldModal
                                                                      }
                                                                      heading="Add Name"
                                                                 >
                                                                      <Grid
                                                                           container
                                                                           spacing={
                                                                                2
                                                                           }
                                                                           sx={{
                                                                                mt: 1,
                                                                           }}
                                                                      >
                                                                           <Grid
                                                                                item
                                                                                xs="12"
                                                                                lg="12"
                                                                           >
                                                                                <UiInput
                                                                                     type="text"
                                                                                     label="Field Name"
                                                                                />
                                                                           </Grid>

                                                                           <Stack
                                                                                spacing={
                                                                                     2
                                                                                }
                                                                                direction="row"
                                                                                justifyContent="end"
                                                                                sx={{
                                                                                     width: "100%",
                                                                                     mt: 3,
                                                                                }}
                                                                           >
                                                                                <UiButton
                                                                                     name="Clear"
                                                                                     variant="outlined"
                                                                                     size="small"
                                                                                />
                                                                                <UiButton
                                                                                     name="Apply"
                                                                                     variant="contained"
                                                                                     size="small"
                                                                                />
                                                                           </Stack>
                                                                      </Grid>
                                                                 </UiModal>
                                                                 <div className="sba-subtable-search">
                                                                      <UiSearch />
                                                                 </div>
                                                            </div>
                                                            <div className="sba-sub-table">
                                                                 <Table
                                                                      size="small"
                                                                      aria-label="purchases"
                                                                 >
                                                                      <TableHead>
                                                                           <TableRow>
                                                                                <TableCell align="left">
                                                                                     Name
                                                                                </TableCell>
                                                                                <TableCell></TableCell>
                                                                           </TableRow>
                                                                      </TableHead>

                                                                      <TableBody>
                                                                           {row.items.map(
                                                                                (
                                                                                     dropitem,
                                                                                     index,
                                                                                ) => {
                                                                                     return (
                                                                                          <TableRow>
                                                                                               <TableCell>
                                                                                                    {
                                                                                                         dropitem.date
                                                                                                    }
                                                                                               </TableCell>

                                                                                               <TableCell align="right">
                                                                                                    <div className="sbt-data-grid__action-bar">
                                                                                                         <Tooltip
                                                                                                              title="Edit"
                                                                                                              placement="top"
                                                                                                              arrow
                                                                                                         >
                                                                                                              <IconButton
                                                                                                                   aria-label="Edit"
                                                                                                                   sx={{
                                                                                                                        ml: 1.5,
                                                                                                                   }}
                                                                                                              >
                                                                                                                   <EditIcon />
                                                                                                              </IconButton>
                                                                                                         </Tooltip>
                                                                                                         <Tooltip
                                                                                                              title="Delete"
                                                                                                              placement="top"
                                                                                                              arrow
                                                                                                         >
                                                                                                              <IconButton
                                                                                                                   aria-label="Delete"
                                                                                                                   sx={{
                                                                                                                        ml: 0.5,
                                                                                                                   }}
                                                                                                              >
                                                                                                                   <DeleteIcon color="error" />
                                                                                                              </IconButton>
                                                                                                         </Tooltip>
                                                                                                    </div>
                                                                                               </TableCell>
                                                                                          </TableRow>
                                                                                     );
                                                                                },
                                                                           )}
                                                                      </TableBody>
                                                                 </Table>
                                                            </div>
                                                       </Box>
                                                  </Collapse>
                                             </TableCell>
                                        </TableRow>
                                   </>
                              ))}
                              {emptyRows > 0 && (
                                   <TableRow
                                        style={{
                                             height: 53 * emptyRows,
                                        }}
                                   >
                                        <TableCell colSpan={6} />
                                   </TableRow>
                              )}
                         </UiTableBody>
                         {/* <UiModal handleClose={handleCloseEdit} open={editModal} heading="Edit Lookup Table" icon={<EditIcon />}>
            <Grid container spacing={2} mt={2}>
              <Grid item xs="12" lg="6" className='sba-search-input' >
                <UiInput type="text" label="Name" />
              </Grid>
              <Grid item xs="12" lg="6" >
                <UiSelect label="Type"
                  value={character}
                  handleChange={handleChangetype} options={options1} />
              </Grid>
              <FormControlLabel control={
                <UiSwitch />}
                label="Active"
                labelPlacement="top"
                sx={{ mt: 2 }}
                className='sba-switch-label' />
            </Grid>
            <Grid container sx={{ display: 'flex', mt: 2, }} >
              <UiButton name="Reset" variant="contained" size="large" color="error" />
              <div className='sbt-right-edit-btn-wr'>
                <UiButton name="Cancel" variant="outlined" size="large" />
                <UiButton name="Add" variant="contained" size="large" />
              </div>
            </Grid>

          </UiModal> */}
                    </UiTableWrapper>
               </div>
               <TablePagination
                    rowsPerPageOptions={[10, 25, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
               />
               
          </>
     );
}
